import Vue from 'vue';

import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/adbazaar{/v}{/type}{/itemId}{/action}{/subAction}`,
  {},
  {
    getSearchTerms: {
      method: 'GET',
      params: { type: 'campaigns', action: 'search-terms' },
    },
  },
);
